import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { createRoot } from 'react-dom/client';
import { SnackbarProvider } from 'notistack';
import { StrictMode } from 'react';
import 'leaflet/dist/leaflet.css';
import { es } from 'date-fns/locale';

import { theme } from './config/theme';
import { mocksServer } from 'config/mocks';
import App from './App.tsx';

import '@core/styles/global.scss';
import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/700.css';

if (import.meta.env.VITE_ENABLE_MOCKS === 'true' && import.meta.env.DEV) {
  mocksServer.start({
    onUnhandledRequest: 'bypass',
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CssBaseline />
    <ThemeProvider theme={theme}>
      <SnackbarProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
          <App />
        </LocalizationProvider>
      </SnackbarProvider>
    </ThemeProvider>
  </StrictMode>
);
